import {useCallback, useEffect, useMemo, useState} from 'react'

const COUNTRY_PRODUCT_TAB_CONFIGS = {
  CO: {
    tabs: [
      {
        id: 'CO03',
        tabLabel: '1PD List',
        title: '1PD List',
        filters: [
          {
            field: 'salesOrg',
            value: 'CO03',
            type: 'string',
          },
        ],
      },
      {
        id: 'CO3P',
        tabLabel: '3PD List',
        title: '3PD List',
        filters: [
          {
            field: 'salesOrg',
            value: 'CO3P',
            type: 'string',
          },
        ],
      },
    ],
  },
}

const getValidTabIndex = (index, length) => {
  if (!Number.isFinite(index)) {
    return 0
  }

  if (length <= 0) {
    return 0
  }

  return Math.min(Math.max(index, 0), length - 1)
}

export const SALES_ORG_STORAGE_KEY = 'salesOrg'

export const useCountryProductTabs = (countryCode = '', productTableRef = null) => {
  const productTabConfig = useMemo(() => COUNTRY_PRODUCT_TAB_CONFIGS[countryCode] ?? null, [countryCode])

  const productTabList = useMemo(() => productTabConfig?.tabs ?? [], [productTabConfig])
  const [activeProductTabIndex, setActiveProductTabIndex] = useState(0)

  useEffect(() => {
    const validIndex = getValidTabIndex(activeProductTabIndex, productTabList.length)

    if (validIndex !== activeProductTabIndex) {
      setActiveProductTabIndex(validIndex)
    }
  }, [activeProductTabIndex, productTabList.length])

  const activeProductTab = productTabList[activeProductTabIndex]
  const productTabFilters = activeProductTab?.filters ?? []

  useEffect(() => {
    if (activeProductTab?.id) {
      sessionStorage.setItem(SALES_ORG_STORAGE_KEY, activeProductTab.id)
      return
    }

    sessionStorage.removeItem(SALES_ORG_STORAGE_KEY)
  }, [activeProductTab])

  const handleProductTabChange = useCallback(
    index => {
      const validIndex = getValidTabIndex(index, productTabList.length)

      if (validIndex === activeProductTabIndex) {
        return
      }

      setActiveProductTabIndex(validIndex)
      productTableRef?.current?.resetAll?.()
    },
    [activeProductTabIndex, productTabList.length, productTableRef]
  )

  return {
    activeProductTabIndex,
    setActiveProductTabIndex,
    handleProductTabChange,
    productTabList,
    productTabFilters,
  }
}
